var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "product-promo",
    class: [("product-promo_" + (_vm.countProduct)), ("product-promo_product-" + (_vm.productAlign))]
  }, [_vm._l(_vm.items, function (item, index) {
    return [_vm.countProduct > index ? _c('nuxt-link', {
      key: index,
      staticClass: "product-promo__item",
      attrs: {
        "to": item.path,
        "data-e2e": "promo-product-card"
      },
      nativeOn: {
        "click": function ($event) {
          return _vm.emit('link-click', {
            product: item,
            index: index
          });
        }
      }
    }, [item.price ? [item.price.bonus ? _c('TSBonusCount', {
      staticClass: "product-promo__labels product-promo__bonus_count",
      attrs: {
        "count": item.price.bonus,
        "size": "regular"
      }
    }) : _vm._e(), _vm._v(" "), item.price.discount ? _c('ProductDiscountMarker', {
      staticClass: "product-promo__labels product-promo__discount_marker",
      attrs: {
        "price": item.price.discount.value,
        "discount": item.price.common.value
      }
    }) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "product-promo__wrap-img"
    }, [_vm.photoLazyload ? [_c('LazyImg', {
      staticClass: "product-promo__img",
      attrs: {
        "img": item.thumbnail.x1,
        "srcset": item.thumbnail.x2,
        "alt": item.name
      }
    })] : [_c('img', {
      staticClass: "product-promo__img",
      attrs: {
        "src": item.thumbnail.x1,
        "srcset": ((item.thumbnail.x2) + " 2x"),
        "alt": item.name
      }
    })]], 2), _vm._v(" "), item.name ? _c('div', {
      staticClass: "product-promo__title"
    }, [_vm._v("\n        " + _vm._s(item.name) + "\n      ")]) : _vm._e(), _vm._v(" "), item.price ? _c('TSPrice', {
      staticClass: "product-promo__price",
      attrs: {
        "price": item.price,
        "size": _vm.priceSize(index),
        "type": "promo"
      }
    }) : _vm._e()], 2) : _vm._e()];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }